import TokenValidationStatus from 'src/utils/constants/cardForm';
import {
  ADD_CARD_TO_CLIENT,
  CLEAR_CARD_FORM_TOKEN,
  GET_CARD_FORM_TOKEN_DATA,
  VALIDATE_CARD_FORM_TOKEN
} from '../actions/cardFormActions';

const initialState = {
  tokenData: null,
  tokenValidationStatus: null,
  savedCard: null
};

const cardFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARD_FORM_TOKEN_DATA: {
      return {
        ...state,
        tokenData: action.payload
      };
    }
    case VALIDATE_CARD_FORM_TOKEN.start: {
      return {
        ...state,
        tokenValidationStatus: TokenValidationStatus.PENDING
      };
    }
    case VALIDATE_CARD_FORM_TOKEN.success: {
      return {
        ...state,
        tokenValidationStatus: TokenValidationStatus.SUCCESS
      };
    }
    case VALIDATE_CARD_FORM_TOKEN.failure: {
      return {
        ...state,
        tokenValidationStatus: TokenValidationStatus.FAILURE
      };
    }
    case CLEAR_CARD_FORM_TOKEN: {
      return {
        ...state,
        tokenData: null,
        tokenValidationStatus: null,
        savedCard: null
      };
    }
    case ADD_CARD_TO_CLIENT.start: {
      return {
        ...state
      };
    }
    case ADD_CARD_TO_CLIENT.success: {
      return {
        ...state,
        savedCard: action.payload
      };
    }
    case ADD_CARD_TO_CLIENT.failure: {
      return {
        ...state
      };
    }
    default: {
      return state;
    }
  }
};

export default cardFormReducer;

